import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import {
  changeExtension,
  changeHomePhone,
  changeIsCheckedExtension,
  changeIsPhoneChecked,
  changeWorkPhone,
} from "../../../redux/Slices/PhoneSlice";
import cmsParser from "../../Services/CMSParser";

const Phone = ({ cmsLabels }) => {
  const {
    isPhoneChecked,
    homePhone,
    workPhone,
    isCheckedExtension,
    extension,
  } = useSelector((state) => state.phone);

  const dispatch = useDispatch();

  return (
    <div className="dds__py-2 dds__border-top">
      <div className="dds__checkbox" role="checkbox">
        <label className="dds__checkbox__label dds__w-100" htmlFor="lrPhoneCheck">
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrPhoneCheck"
            id="lrPhoneCheck"
            value="lg"
            onChange={() => dispatch(changeIsPhoneChecked(!isPhoneChecked))}
          />
          <span tabIndex="-1">{cmsParser(cms.Phone, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isPhoneChecked ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-8 dds__col--xl-6">
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblHomePhone" htmlFor="txtHomePhone">
                 {cmsParser(cms.Home_Phone, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="30"
                    name="txtHomePhone"
                    id="txtHomePhone"
                    aria-labelledby="lblHomePhone"
                    onChange={(e) => dispatch(changeHomePhone(e.target.value))}
                    value={homePhone}
                  />
                  <div
                    id="homephone-input-feedback"
                    className="dds__invalid-feedback"
                  >
                    Please enter a valid home phone number.
                  </div>
                </div>
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblWorkPhone" htmlFor="txtWorkPhone">
                  {cmsParser(cms.Work_Phone, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="30"
                    name="txtWorkPhone"
                    id="txtWorkPhone"
                    required=""
                    aria-labelledby="lblWorkPhone"
                    onChange={(e) => dispatch(changeWorkPhone(e.target.value))}
                    value={workPhone}
                  />
                  <div
                    id="workphone-input-feedback"
                    className="dds__invalid-feedback"
                  >
                    Please enter a valid home number.
                  </div>
                </div>
              </div>
            </div>

            {isCheckedExtension && (
              <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
                <div className="dds__col--md-4 dds__text-md-right">
                  <label id="lblExtention" htmlFor="txtExtension">
                    {cmsParser(cms.Extension, cmsLabels)}
                  </label>
                </div>
                <div className="dds__col--md-8">
                  <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                    <input
                      type="text"
                      className="dds__input-text"
                      maxLength="30"
                      name="txtExtension"
                      id="txtExtension"
                      required=""
                      aria-labelledby="lblExtention"
                      onChange={(e) =>
                        dispatch(changeExtension(e.target.value))
                      }
                      value={extension}
                    />
                    <div
                      id="extention-input-feedback"
                      className="dds__invalid-feedback"
                    >
                      Please enter a valid extension.
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="dds__row">
              <div className="dds__col--md-8 dds__ml-auto dds__pl-lg-3">
                <button
                  type="button" role="button"
                  onClick={() =>
                    dispatch(changeIsCheckedExtension(!isCheckedExtension))
                  }
                  className="dds__button dds__button--tertiary dds__button--sm dds__my-2"
                >
                  + {cmsParser(cms.Add_Extension, cmsLabels)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
